export default __webpack_public_path__ + "static/media/POTS.b326880e.png";